var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.$style.collaboratorsThumbnails]},[_c('div',{class:[
      _vm.$style.collaboratorsThumbnail,
      _vm.$style.collaboratorsThumbnail__main
    ]},[_vm._v(" "+_vm._s(_vm.getInitialFromName(_vm.documentOwnerName))+" ")]),_vm._l((_vm.collaboratorsName),function(name,i){return [(i < 5)?_c('div',{key:name + i,class:_vm.$style.collaboratorsThumbnail},[_vm._v(" "+_vm._s(_vm.getInitialFromName(name))+" ")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }